import { LightbulbCflSpiralOffIcon } from './LightbulbCflSpiralOffIcon';

/**
 * author: Michael Irigoyen
 * id 49D60773-F400-491A-AD3F-B50110089F63
 * name lightbulb-cfl-spiral-off
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-cfl-spiral-off.svg
 * tags
 * - Home Automation 
 */
export const BulbCflSpiralOffIcon = LightbulbCflSpiralOffIcon;
export default BulbCflSpiralOffIcon